import { Resource as b, API as i } from "@coveo/platform-client";
import { BackendOnlyResource as d } from "./BackendOnlyResource.js";
const l = (t) => "errorInfo" in t, h = (t) => !t.queryResponses.some(l), c = async (t) => {
  const e = await t;
  if (h(e))
    return e;
  throw Object.defineProperty(
    new Error(
      e.queryResponses.reduce((r, n, p) => l(n) ? r + `
 [${p}] ${n.errorInfo.errorCode}` : r, "Queries encountered one or more errors:")
    ),
    "queryResponses",
    { enumerable: !0, value: e.queryResponses }
  );
}, s = class s extends b {
  /**
   * List the tables available to the current user and organization.
   *
   * @param pagination Optional pagination query parameters.
   * @param args Optional RequestInit args, most often used to pass an abort signal.
   * @returns The response{@link DataServiceListTablesResponseModel}.
   */
  listTables(e, r) {
    return this.api.get(
      super.buildPath(`${s.baseUrl}/tables`, e),
      r
    );
  }
  query(e, r) {
    return this.api.post(
      super.buildPath(`${s.baseUrl}/query`),
      e,
      r
    );
  }
  queries(e, r) {
    return c(
      this.api.post(
        super.buildPath(`${s.baseUrl}/queries`),
        e,
        r
      )
    );
  }
  export(e, r) {
    return this.api.post(
      super.buildPath(`${s.baseUrl}/export`),
      e,
      r
    );
  }
};
s.baseUrl = `/rest/organizations/${i.orgPlaceholder}/data/v1`;
let u = s;
const o = class o extends d {
  constructor(e, r, n) {
    super(e, r, n);
  }
  listTables(e, r) {
    return this.internalAPI.get(
      super.buildPath(`${o.baseUrl}/tables`, e),
      r
    );
  }
  query(e, r) {
    return this.internalAPI.post(
      super.buildPath(`${o.baseUrl}/query`),
      e,
      r
    );
  }
};
o.baseUrl = `/data/restricted/organizations/${i.orgPlaceholder}/data/v1`;
let a = o;
export {
  u as DataServiceResource,
  a as RestrictedDataServiceResource
};
//# sourceMappingURL=DataServiceResource.js.map
